// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__fG7-r","emails":"CreateEditClinics_emails__hXV6G","emailTagLabel":"CreateEditClinics_emailTagLabel__K5-A0"};